/** @jsxImportSource @emotion/react */
import React from 'react';

import ProductsListComponent from './ProductsListComponent';

function ProductList({ products }) {
    return (
        <div>
            {products.map((product) => (
                <ProductsListComponent key={product.id} product={product} />
            ))}
        </div>
    );
}

export default ProductList;
